import React from "react";
import ListLayout from "app/components/shared/listLayout";
import { WHY_CHOOSE_CLOUDMYLAB_LIST } from "./constants";
import { SectionDivider } from "app/components/shared/SectionDivider";

const Features = () => {
  return (
    <>
      <SectionDivider label={"Why Choose CloudMyLab's Lab as a Service?"} />
      <ListLayout data={WHY_CHOOSE_CLOUDMYLAB_LIST} />
    </>
  );
};

export default Features;
